module.exports = __webpack_public_path__ + "img/hone_user.b6896c1d.svg";